import {gsap} from "gsap";
import Swiper from 'swiper';
import { Pagination, Manipulation, Navigation, Controller } from 'swiper/modules';


export const ViewCases = {
    namespace: 'case',
    beforeEnter(data) {

    },
    afterLeave() {



    },
    afterEnter() {



        console.log('cases');

        document.querySelector('.header').classList.add('inverted');


        let $filters = document.querySelectorAll('.block-case__filters a');

        $filters.forEach(el=>{

            el.addEventListener('click',()=>{

                $filters.forEach(item=>{
                    item.classList.remove('active');
                })

                el.classList.add('active')

                let target = el.dataset.filter;

                if (target == '') {
                    target = '.block-case__item-w';
                }



                gsap.set('.block-case__item-list',{
                    height: () => {

                        return document.querySelector('.block-case__item-list').clientHeight

                    }
                })


                console.log(target)

                gsap.to('.block-case__item-w.active',{
                    stagger: 0.2,
                    opacity: 0,
                    onComplete: () => {
                        gsap.set('.block-case__item-w',{
                            display: 'none'
                        })

                        gsap.to(target,{
                            stagger: 0.2,
                            opacity: 1,
                            delay:.1,
                            onStart: () => {
                                gsap.set('.block-case__item-list',{
                                    clearProps: 'all'
                                })
                                gsap.set(target,{
                                    display: 'block',
                                    opacity: 0
                                })
                            },
                            onComplete: () => {

                                document.querySelectorAll('.block-case__item-w').forEach(el=>{
                                    el.classList.remove('active');
                                })

                                document.querySelectorAll(target).forEach(el=>{
                                    el.classList.add('active');
                                })
                            }
                        })


                    }
                })

            })
        })




    }
}
